import React from "react";
import { withRouter } from "us.common/wIthRouter";
import IO from "us.collection.input-output";

interface ICnt_RegisterInvoice {}

const Cnt_RegisterInvoice: React.FC<ICnt_RegisterInvoice> = (props) => {
  return (
    <IO.Components.RegisterInvoice.Home
      {...props}
      history={(props as any).history}
    />
  );
};

export default withRouter(Cnt_RegisterInvoice);
